//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

export enum CollectionStatusType { // should match COLLECTION_SETTINGS.STATUS_KEYS in constants.angular.js
  Unmoderated = 'Unmoderated',
  Rejected = 'Rejected',
  Approved = 'Approved',
}
